<template>
    <site-img
        class="md-team double-column-simple"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="{
            backgroundColor: bgType === 'color' ? bgColor : '',
            paddingTop,
            marginBottom
        }"
        v-if="allTotal > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div
                class="mg-title"
                v-if="fmtTitle"
                v-html="formatFontSize(fmtTitle, '--mg-title-size')"
            ></div>
            <!-- SEARCH BAR START -->
            <template v-if="showSearchBar">
                <search-bar
                    :forAgentName="$t('md-team.agentName')"
                    :forAddress="$t('md-team.location')"
                    @search="searchAgents"
                />
            </template>
            <Empty v-if="agents.length === 0" />
            <!-- SEARCH BAR END -->
            <div class="agent-container">
                <div class="agent-item" v-for="agent in agents" :key="agent.id">
                    <div class="agent-wrapper clearfix">
                        <div class="agent-image">
                            <a
                                :href="useExternalUrl ? agent.externalUrl || agent.detailUrl : agent.detailUrl"
                                :target="detailUrlTarget"
                                rel="noopener noreferrer"
                                :aria-label="agentAlt(agent)"
                            >
                                <AgentHeadShot class="agent-img md-team-double-column-simple" :agent="agent" />
                                <p class="agent-pos" v-if="!!agent.position">
                                    {{ agent.position }}
                                </p>
                            </a>
                        </div>
                        <div class="agent-info">
                            <div class="agent-info-name">
                                <a
                                    :href="agent.detailUrl"
                                    :target="detailUrlTarget"
                                    rel="noopener noreferrer"
                                >
                                    <p class="agent-name info-item">
                                        {{ agent.fullName }}
                                    </p>
                                </a>
                                <p v-if="agent.license">
                                    {{ licenseName }}{{ agent.license }}
                                </p>
                                <a
                                    v-if="!!agent.phone"
                                    class="agent-phone info-item"
                                    :href="'tel:' + agent.phone"
                                    target="_top"
                                    rel="noopener noreferrer"
                                >
                                    <span
                                        class="iconfont icon-call-small"
                                    ></span>
                                    <span class="text">
                                        {{ $ft.formatPhone(agent.phone) }}
                                    </span>
                                </a>
                                <a
                                    v-if="!!agent.email"
                                    class="agent-email info-item"
                                    :href="'mailto:' + agent.email"
                                    :title="$t('common:link.mailtoTitle')"
                                    :aria-label="
                                        $t('common:link.mailtoAriaLabel', {
                                            email: agent.email
                                        })
                                    "
                                    target="_top"
                                    rel="noopener noreferrer"
                                >
                                    <span
                                        class="iconfont icon-agent-email"
                                    ></span>
                                    <span class="text">{{ agent.email }}</span>
                                </a>
                                <a
                                    v-if="!!agent.externalUrl"
                                    class="agent-website info-item"
                                    :href="agent.externalUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span class="iconfont icon-website2"></span>
                                    <span class="text">
                                        {{ agent.externalUrl }}
                                    </span>
                                </a>
                            </div>
                            <ShareLink
                                v-if="
                                    agent.agentSocialNetworks &&
                                        agent.agentSocialNetworks.length > 0
                                "
                                :socialNetworks="agent.agentSocialNetworks"
                            />
                        </div>
                    </div>
                    <div class="agent-intro">
                        <div
                            class="intro-detail"
                            v-if="agent.longIntroduction"
                            v-html="agent.longIntroduction"
                        ></div>
                    </div>
                </div>
            </div>
            <pagination
                v-if="total > 1"
                :totalPage="total"
                @pageChange="pageChange"
                :pageSize="pageSize"
                :noScroll="true"
                :pageNum="pageNum"
            />
        </module-box>
    </site-img>
</template>

<script>
import common from '../index';
import ShareLink from './share-link.vue';
import { normal } from '../../defaultSpacing';
import search from '../search';
export default {
    data: function() {
        return {
            ...normal
        };
    },
    computed: {
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        }
    },
    mixins: [common, search],
    components: { ShareLink }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.double-column-simple {
    .agent-container {
        margin-bottom: -20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .agent-item {
            width: calc((100% - 20px) / 2);
            border: 1px solid var(--color-border);
            margin-bottom: 20px;
            background-color: #fff;
            .agent-wrapper {
                display: flex;
                padding: 15px;
            }
            .agent-image {
                position: relative;
                width: 150px;
                height: 150px;
                overflow: hidden;
                margin-right: 16px;
                .agent-img {
                    width: 100%;
                    height: 100%;
                }
                .agent-pos {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    color: #fff;
                    background-color: rgba(0, 0, 0, 0.5);
                    text-align: center;
                    height: 20px;
                    width: 100%;
                    line-height: 20px;
                    font-size: 14px;
                }
            }
            .agent-info {
                width: calc(100% - 170px);
                .info-item {
                    @include ellipsis();
                    font-size: 14px;
                    line-height: 22px;
                    color: #282828;
                    display: block;
                    .iconfont {
                        vertical-align: middle;
                        color: #282828;
                        font-size: 12px;
                        margin-right: 5px;
                    }
                    &.agent-name {
                        font-family: var(--font-bold);
                        font-size: 20px;
                        margin-bottom: 11px;
                        line-height: 24px;
                    }
                }
                .share-links.double-column-simple {
                    margin-left: -6px;
                    margin-top: 15px;
                    .ad .iconfont {
                        margin: 0 6px;
                    }
                }
            }
            .agent-intro {
                height: 150px;
                display: flex;
                background-color: #fff;
                &:empty {
                    display: none;
                }
                .intro-detail {
                    color: #787878;
                    margin: 15px;
                    line-height: 24px;
                    overflow: auto;
                    font-size: 14px;
                    @include always-show-scroll();
                }
            }
        }
    }
    @include media-800 {
        .agent-container .agent-item {
            width: 100%;
        }
    }
    @include media-600 {
        .agent-container .agent-item {
            .agent-wrapper {
                position: relative;
                display: block;
            }
            .agent-image {
                width: 100px;
                height: 100px;
                display: inline-block;
            }
            .agent-info {
                width: 100%;
                float: right;
                width: calc(100% - 120px);
                .agent-info-name {
                    .agent-name {
                        white-space: inherit;
                        margin-bottom: 4px;
                        word-break: break-word;
                    }
                }
            }
        }
    }
    .comp-pagination {
        margin-bottom: 20px;
    }
    .com-search-bar {
        padding-bottom: 30px;
        border-bottom: 1px solid #dcdcdc;
        margin-bottom: 30px;
        .search-item {
            & + .search-item {
                @include adapter((margin-left, 10px, 0));
            }
        }
        .search-buttoon {
            margin-left: 10px;
        }
        @include adapter(
            (padding-bottom, 30px, 20px),
            (margin-bottom, 30px, 20px)
        );
        input {
            border-radius: 2px;
            background-color: #f0f0f0;
            box-shadow: none;
            border: none;
        }
        button {
            padding: 0 40px;
        }
        ::-webkit-input-placeholder {
            color: #bebebe;
        }
    }
    .mg-container {
        overflow: visible;
    }
}
</style>
